import { apiSlice } from '../app/api/apiSlice';

export const MetaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createFeedback: builder.mutation({
      query: (payload) => ({
        url: '/feedback',
        method: 'POST',
        body: { ...payload },
      }),
    }),
  }),
});

export const { useCreateFeedbackMutation } = MetaApiSlice;
